import { Button, ButtonGroup, ButtonGroupProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import { colors } from '../../../../Constants/Colors';

export const StyledReportsButtonGroup = styled(ButtonGroup)<ButtonGroupProps>`
  & .MuiButtonGroup-grouped:not(:last-of-type) {
    border-color: ${colors.GRAY};
  }
`;

export const ReportsButton = styled(Button)`
  &.MuiButton-contained {
    background-color: transparent;
    &:hover {
      background-color: rgba(194, 194, 194, 0.1);
    }
  }
`;
